__turbopack_context__.v({
  "animateFlag": "Flag-module__csDy_a__animateFlag",
  "flagImage": "Flag-module__csDy_a__flagImage",
  "flagWrapper": "Flag-module__csDy_a__flagWrapper",
  "flutter": "Flag-module__csDy_a__flutter",
  "root": "Flag-module__csDy_a__root",
  "showPoll": "Flag-module__csDy_a__showPoll",
  "wave": "Flag-module__csDy_a__wave",
});
